<template>
    <b-badge :variant="badgeVariant" class="badge-language">
        <feather-icon v-if="field === null" icon="GlobeIcon" class="mr-50 text-dark" />
        <span v-else class="flag-icon mr-50" :class="flagIconCode" />
        <span class="text-dark">{{ badgeText }}</span>
    </b-badge>
</template>

<script>
import { BBadge } from "bootstrap-vue";
import "flag-icon-css/css/flag-icons.min.css";
import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue";

export default {
    name: "LanguageBadge",
    components: {
        BBadge,
        FeatherIcon,
    },
    props: {
        field: {
            type: String,
            default: null,
        },
        row: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        flagIconCode() {
            let code;
            switch (this.field) {
                case "en":
                    code = "gb";
                    break;
                case "tr":
                    code = "tr";
                    break;
                default:
                    code = "xx";
            }
            return `flag-icon-${code}`;
        },
        badgeVariant() {
            switch (this.field) {
                case null:
                    return "light-dark";
                case "tr":
                    return "light-danger";
                case "en":
                    return "light-primary";
                default:
                    return "light-secondary";
            }
        },
        badgeText() {
            if (this.field === null) return "Global";
            return this.field.toUpperCase();
        },
    },
};
</script>

<style scoped>
.badge-language {
    display: inline-flex;
    align-items: center;
}
</style>
